import React from "react";

const HotelShortReview = ({ text }) => (
  <span className="editor-comment">
    <span itemProp="reviewBody">{text}</span>
  </span>
);

export default HotelShortReview;
